import React from "react";

import styles from "./index.modules.less";
interface ISplitTextProps {
  label: string;
  /** 容器寬度 */
  width: number;
  cls?: string;
}

const SplitText: React.FC<ISplitTextProps> = (props: ISplitTextProps) => {
  const { label = "", width, cls } = props;

  return (
    <div className={`flex items-center justify-between ${cls}`} style={{ width }}>
      {label.split("").map((t) => (
        <span key={t}>{t}</span>
      ))}
    </div>
  );
};

export default SplitText;
